import { render, staticRenderFns } from "./IconCookie.vue?vue&type=template&id=115aac94&"
import script from "./IconCookie.vue?vue&type=script&lang=js&"
export * from "./IconCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports